var _defs, _polygon, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack5Solid21({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "7.78 0.75 0.28 15.24 15.28 15.24 7.78 0.75"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.71,12.78V7.06H6.87V9.6L9.2,7.06h1.56L8.6,9.29l2.27,3.49H9.38L7.8,10.1l-.93,1v1.73Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack5Solid21);
export default __webpack_public_path__ + "static/media/Symbolpack_5_solid_21.9f51e00dae2084b46cf8f1725a698c0f.svg";
export { ForwardRef as ReactComponent };